import { IbDeskProvider } from '@frontends/feature-ib';
import { type PropsWithChildren } from 'react';
import useAuth from '@/hooks/useAuth';
import { useEntityConfig } from '@/hooks/useEntityConfig';
import { useIsIbDeskRoute } from '@/hooks/useIbDeskSection';
import { ibHttpClient } from '@/lib/ibHttpClient';
import { type EnhancedClientSummaryResponse } from '@/types/Auth';
import { IbMembershipGate } from './IbMembershipGate';

const SYMBOL_ICONS_BASE_URL = '/assets/icons';

interface IbDeskGatewayProps extends PropsWithChildren {
  currentClient: EnhancedClientSummaryResponse | undefined;
}

export const IbDeskGateway = ({ currentClient, children }: IbDeskGatewayProps) => {
  const { client: storedClient } = useAuth();
  const config = useEntityConfig();
  const isIbDeskRoute = useIsIbDeskRoute();

  // useClientQuery copies /clients/current into AuthContext in an effect, so the first render after the spinner
  // has no stored client yet; without the query data IB Desk would flash its no-programs state
  const client = storedClient ?? currentClient;

  return (
    <IbDeskProvider
      http={ibHttpClient}
      baseUrl={config.VITE_URL_IB}
      externalId={client?.client_details ? String(client.client_details.id) : null}
      isAvailable={config.VITE_IB_DESK_ENABLED}
      isEnabled={config.VITE_IB_DESK_ENABLED && isIbDeskRoute}
      isMocksEnabled={config.VITE_IB_MOCKS}
      switchBonusTermsUrl={config.VITE_IB_SWITCH_BONUS_TERMS_URL}
      symbolIconsBaseUrl={SYMBOL_ICONS_BASE_URL}
    >
      <IbMembershipGate>{children}</IbMembershipGate>
    </IbDeskProvider>
  );
};
